import {Alert, Breadcrumb, Button, Space, Tabs} from "antd";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {UnavailabilityTabContent} from "../../../../components/calls/availability";
import {DashboardWrapper} from "../../../../layouts/dashboard-wrapper";
import {StyledPageWrapper} from "../../../../styles/dashboard/calls/calls";
import {StartTimeFrequency} from "../../../../components/calls/availability/booking-notice";
import {MinimumNoticePeriod} from "../../../../components/calls/availability/booking-notice/minimum-notice-period";
import {useGetMinimumNoticePeriod} from "../../../../react-query-hooks/availability";
import {ErrorBoundary} from "react-error-boundary";
import {GetUserSchedulesPage} from "../../../../availability/use-cases/schedule/get-schedules/page";
import {useEffect, useState} from "react";

type TabKeys = "availability" | "unavailability" | "bookingLimits";

const AvailabilityPage = () => {
  // const {tabKey} = useParams();
  const getMinimumNoticePeriodQuery = useGetMinimumNoticePeriod();
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("activeTab");
  const [defaultActiveKey, setDefaultActiveKey] = useState<TabKeys>("availability");
  const navigate = useNavigate();

  useEffect(() => {
    if (activeTab) {
      if (activeTab === "unavailability") {
        setDefaultActiveKey(activeTab);
      }
      if (activeTab === "bookingLimits") {
        setDefaultActiveKey(activeTab);
      }
      if (activeTab === "availability") {
        setDefaultActiveKey(activeTab);
      }
      // setDefaultActiveKey("withdrawal");
    }
  }, [activeTab]);

  function handleTabClick(key: string) {
    if (key === "availability") {
      setDefaultActiveKey("availability");
      navigate("/calls/availability?activeTab=availability");
    }
    if (key === "unavailability") {
      setDefaultActiveKey("unavailability");
      navigate("/calls/availability?activeTab=unavailability");
    }
    if (key === "bookingLimits") {
      setDefaultActiveKey("bookingLimits");
      navigate("/calls/availability?activeTab=bookingLimits");
    }
  }
  return (
    <DashboardWrapper pageTitle="Availability">
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/calls">1:1 Sessions</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Availability</Breadcrumb.Item>
      </Breadcrumb>
      <StyledPageWrapper>
        <div className="main-area">
          <Tabs
            defaultActiveKey={defaultActiveKey}
            activeKey={defaultActiveKey}
            onTabClick={(key) => handleTabClick(key)}
          >
            <Tabs.TabPane tab="Availability" key="availability">
              <ErrorBoundary
                FallbackComponent={({error, resetErrorBoundary}) => (
                  <div>
                    <Alert
                      message="Sorry, something went wrong."
                      showIcon
                      description={error.message}
                      type="error"
                      action={
                        <Button
                          onClick={() => {
                            resetErrorBoundary();
                          }}
                          size="small"
                          danger
                        >
                          Reset
                        </Button>
                      }
                    />
                  </div>
                )}
              >
                {/* <Availability /> */}
                <GetUserSchedulesPage />
              </ErrorBoundary>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Unavailability" key="unavailability">
              <ErrorBoundary
                FallbackComponent={({error, resetErrorBoundary}) => (
                  <div>
                    <Alert
                      message="Sorry, something went wrong."
                      showIcon
                      description={error.message}
                      type="error"
                      action={
                        <Button
                          onClick={() => {
                            resetErrorBoundary();
                          }}
                          size="small"
                          danger
                        >
                          Reset
                        </Button>
                      }
                    />
                  </div>
                )}
              >
                <UnavailabilityTabContent />
              </ErrorBoundary>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Booking limits" key="bookingLimits">
              <ErrorBoundary
                FallbackComponent={({error, resetErrorBoundary}) => (
                  <div>
                    <Alert
                      message="Sorry, something went wrong."
                      showIcon
                      description={error.message}
                      type="error"
                      action={
                        <Button
                          onClick={() => {
                            resetErrorBoundary();
                          }}
                          size="small"
                          danger
                        >
                          Reset
                        </Button>
                      }
                    />
                  </div>
                )}
              >
                <Space size={24} direction="vertical" style={{display: "flex"}}>
                  {getMinimumNoticePeriodQuery.isLoading ? (
                    <></>
                  ) : getMinimumNoticePeriodQuery.isError ? (
                    <Alert
                      message="Error"
                      description={getMinimumNoticePeriodQuery.error.message}
                      type="error"
                      showIcon
                    />
                  ) : (
                    <MinimumNoticePeriod
                      noticePeriod={getMinimumNoticePeriodQuery.data.noticePeriod}
                    />
                  )}
                  <StartTimeFrequency />
                </Space>
              </ErrorBoundary>
            </Tabs.TabPane>
            {/* <Tabs.TabPane
              tab={
                <>
                  <span>Calendar</span>
                  <Tag style={{marginLeft: "1rem"}} color="blue">
                    Coming soon
                  </Tag>
                </>
              }
              key="3"
              disabled
            >
              <CalendarTabContent />
            </Tabs.TabPane> */}
          </Tabs>
        </div>
      </StyledPageWrapper>
    </DashboardWrapper>
  );
};

export {AvailabilityPage};
